import gql from "graphql-tag";

// Resolver signature confirmed against mediajel-gql-service
// src/webapp/schema.graphql:
//   getHashedEmailPublishStatus(hashedEmailListId: ID!, orgID: ID!): JSON
// orgID is required — the resolver enforces tenant scoping and rejects the
// call without it.
const GET_HASHED_EMAIL_PUBLISH_STATUS = gql`
  query getHashedEmailPublishStatus($hashedEmailListId: ID!, $orgID: ID!) {
    getHashedEmailPublishStatus(
      hashedEmailListId: $hashedEmailListId
      orgID: $orgID
    )
  }
`;

export default GET_HASHED_EMAIL_PUBLISH_STATUS;
